
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkits/library/[slug]",
      function () {
        return require("private-next-pages/toolkits/library/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkits/library/[slug]"])
      });
    }
  